import React from 'react';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  limit,
  onLimitChange,
  totalItems,
  isDarkMode = false,
}) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    const halfVisible = Math.floor(maxVisiblePages / 2);

    let startPage = Math.max(1, currentPage - halfVisible);
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const muted = isDarkMode ? 'text-gray-400' : 'text-gray-600';
  const control = isDarkMode
    ? 'bg-gray-800 border-gray-600 text-gray-200 hover:bg-gray-700'
    : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50';
  const active = 'bg-blue-600 border-blue-600 text-white';
  const disabled = 'disabled:opacity-50 disabled:cursor-not-allowed';

  if (!totalPages || totalPages <= 0) return null;

  return (
    <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4">
      <div className="flex items-center gap-2">
        <select
          value={limit}
          onChange={(e) => onLimitChange && onLimitChange(Number(e.target.value))}
          className={`border rounded p-2 text-sm ${isDarkMode ? 'bg-gray-800 border-gray-600 text-gray-200' : 'bg-white border-gray-300 text-gray-700'}`}
        >
          <option value={5}>5 per page</option>
          <option value={10}>10 per page</option>
          <option value={20}>20 per page</option>
          <option value={50}>50 per page</option>
        </select>
        {typeof totalItems === 'number' && (
          <span className={`text-sm ${muted}`}>
            Showing {Math.min((currentPage - 1) * limit + 1, totalItems)} to{' '}
            {Math.min(currentPage * limit, totalItems)} of {totalItems} entries
          </span>
        )}
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 border rounded text-sm ${control} ${disabled}`}
        >
          First
        </button>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 border rounded text-sm ${control} ${disabled}`}
        >
          Previous
        </button>

        {getPageNumbers().map((pageNum) => (
          <button
            key={pageNum}
            onClick={() => onPageChange(pageNum)}
            className={`px-3 py-1 border rounded text-sm ${currentPage === pageNum ? active : control}`}
          >
            {pageNum}
          </button>
        ))}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 border rounded text-sm ${control} ${disabled}`}
        >
          Next
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 border rounded text-sm ${control} ${disabled}`}
        >
          Last
        </button>
      </div>
    </div>
  );
};

export default Pagination;
